import VueRouter from "vue-router";
import AdminDashboard from "./views/admin/Dashboard";
import Email from "./views/admin/email";
import AdminProfile from "./views/admin/Profile";
import Register from "./views/auth/Register";
import Users from "./views/admin/Users";
import AdminCardRequests from "./views/admin/CardRequests";
import AdminCards from "./views/admin/Cards";
import AdminLoanRequests from "./views/admin/Loans";
import AdminGrantRequests from "./views/admin/Grants";
import AdminUserEdit from "./views/admin/user/Edit";
import Administration from "./views/admin/settings/Administration";
import Gateways from "./views/admin/settings/Gateways";
import Rates from "./views/admin/settings/Rates";
import Notifications from "./views/admin/settings/Notifications";
import Settings from "./views/admin/settings/Settings";
import Banks from "./views/admin/settings/Banks";
import Locations from "./views/admin/settings/Locations";
import Contacts from "./views/admin/settings/Contacts";
import MobileDashboard from "./views/user/mobile/App.vue";
import MobileOverview from "./views/user/mobile/Overview.vue";
import MobileCard from "./views/user/mobile/Card.vue";
import MobileSettings from "./views/user/mobile/Settings.vue";
import MobileBills from "./views/user/mobile/Bills.vue";
import MobileLoans from "./views/user/mobile/Loans.vue";
import MobileGrants from "./views/user/mobile/Grants.vue";
import MobileTransactions from "./views/user/mobile/Transactions.vue";
import MobileAccounts from "./views/user/mobile/Accounts.vue";
import MobileSupport from "./views/user/mobile/Support.vue";

export let routes = [
    // admin routes
    {
        path: "/management/dashboard",
        name: "admin-dashboard",
        component: AdminDashboard
    },
    {
        path: "/management/users",
        name: "users",
        component: Users
    },
    {
        path: "/management/user/edit/:id",
        name: "adminUserEdit",
        component: AdminUserEdit
    },
    {
        path: "/management/administration",
        name: "admins",
        component: Administration
    },
    {
        path: "/management/gateways",
        name: "gateways",
        component: Gateways
    },
    {
        path: "/management/loan-requests",
        name: "loanRequests",
        component: AdminLoanRequests
    },
    {
        path: "/management/grant-requests",
        name: "grantRequests",
        component: AdminGrantRequests
    },
    {
        path: "/management/card-requests",
        name: "cardRequests",
        component: AdminCardRequests
    },
    {
        path: "/management/cards",
        name: "creditcards",
        component: AdminCards
    },
    {
        path: "/management/Rates",
        name: "Rates",
        component: Rates
    },
    {
        path: "/management/settings",
        name: "settings",
        component: Settings
    },
    {
        path: "/management/banks",
        name: "banks",
        component: Banks
    },
    {
        path: "/management/locations",
        name: "locations",
        component: Locations
    },
    {
        path: "/management/beneficiaries",
        name: "contacts",
        component: Contacts
    },
    {
        path: "/management/notification-settings",
        name: "notif-settings",
        component: Notifications
    },
    {
        path: "/management/email",
        name: "email",
        component: Email
    },
    {
        path: "/management/profile",
        name: "AdminProfile",
        component: AdminProfile
    },

    //Authentication
    {
        path: "/register",
        name: "register",
        component: Register
    },

    //mobile views
    {
        path: "/m",
        component: MobileDashboard,
        children: [
            {
                path: "overview",
                component: MobileOverview
            },
            {
                path: "cards",
                component: MobileCard
            },
            {
                path: "settings",
                component: MobileSettings
            },
            {
                path: "bill-payment",
                component: MobileBills
            },
            {
                path: "loans",
                component: MobileLoans
            },
            {
                path: "grants",
                component: MobileGrants
            },
            {
                path: "transactions",
                component: MobileTransactions,
                name: "mobile-transactions"
            },
            {
                path: "my-accounts",
                component: MobileAccounts,
                name: "mobile-accounts"
            },
            {
                path: "support",
                component: MobileSupport,
                name: "mobile-support"
            },
            {
                path: "*",
                name: "error",
                component: MobileOverview
            }
        ]
    },

    //general route
    // {
    //     path: "*",
    //     name: "error",
    //     component: walletOverview
    // }
];
